



















































































import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import RatingBanner from '@/components/Profile/Ratings/RatingBanner.vue';
import ScrollTable from '@/components/.global/ScrollTable/ScrollTable.vue';
import { ActorPortfolioModel } from '@model';
import { ActorsApi } from '@/api';
import VideoGallery from '@/components/Profile/Video/Gallery/VideoGallery.vue';

const states = {
    idle: 'idle',
    saving: 'saving',
    saved: 'saved',
    error: 'error',
};

const ms = 2000;

export default Vue.extend({
    name: 'Portfolio',

    data() {
        return {
            states,
            state: states.idle,
            mimes: ['audio/mpeg', 'audio/mp3'],
            poll: null,
            tableConfig: [
                {
                    id: 0,
                    caption: '',
                    type: 'text',
                    width: 0,
                    flex: 0,
                    hidden: true,
                },
                {
                    id: 1,
                    caption: '',
                    type: 'text',
                    width: 0,
                    flex: 0,
                    hidden: true,
                },
                {
                    id: 2,
                    caption: 'Play',
                    type: 'player',
                    visualizer: 'profile',
                    width: 0,
                    flex: 0,
                    hidden: false,
                },
                {
                    id: 3,
                    caption: 'File name',
                    type: 'text',
                    width: 0,
                    flex: 2,
                    bold: true,
                    hidden: false,
                    editable: true,
                },
                {
                    id: 4,
                    caption: 'url',
                    type: 'text',
                    hidden: true,
                },
                {
                    id: 5,
                    caption: 'Remove',
                    type: 'remove',
                    width: 0,
                    flex: 0,
                    hidden: false,
                },
            ],
        };
    },

    mounted() {
        this.images = this.getActorGallery;
    },

    methods: {
        ...mapActions(['uploadActorAudio']),

        findItemByFileId(file_id: string) {
            for (let i in this.getActor.portfolio) {
                if (this.getActor.portfolio[i].file_id == file_id) {
                    return this.getActor.portfolio[i];
                }
            }
        },

        save(row: any, key: string, value: string) {
            // Zatial natvrdo iba nazov
            if (key != 'nazov') return;

            const foundItem = this.findItemByFileId(row.file_id);

            if (!foundItem || foundItem.nazov == value) {
                return;
            }

            foundItem.nazov = value;

            this.submit();
        },

        dragEnd(e: any, newItems: any[]) {
            // Reorder
            for (let i in newItems) {
                for (let j in this.getActor.portfolio) {
                    if (this.getActor.portfolio[j].id == newItems[i].id) {
                        this.getActor.portfolio[j].poradie = parseInt(i);
                    }
                }
            }

            // Reorder array
            this.getActor.portfolio = this.getActor.portfolio.sort((a: any, b: any) => a.poradie - b.poradie);

            this.submit();
        },

        openFileSelect() {
            this.$refs.file.click();
        },

        async removePortfolioItem(item: any) {
            if (this.$_stateIs(states.saving)) {
                return;
            }

            this.$_setState(states.saving);
            this.getActor.removePortfolioItem(item);
            try {
                await ActorsApi.removeActorPortfolio(item);
                this.$_setState(states.saved);
            } catch (e) {
                this.$_setState(null, states.error);
                throw e;
            } finally {
                this.$_setState(null, states.idle);
            }
        },

        async fileSelected(event: any) {
            if (this.$_stateIs(states.saving)) {
                return;
            }

            const format = '.mp3';
            const file = event.target.files[0];

            this.$bugsnag.leaveBreadcrumb('Validating portfolio audio', {
                name: file.name,
                size: file.size,
                mime: file.type,
            });

            if (!this.mimes.includes(file.type) || !file.name.includes(format)) {
                const e = 'Please select audio MP3 file';
                this.$bugsnag.notify(e);
                alert(e);
                return;
            }

            this.$_setState(states.saving);
            this.$refs.uploadBtn.setLoading();
            try {
                const { data } = await ActorsApi.createActorPortfolio(
                    this.getActor,
                    {
                        file_type: 'audio',
                        nazov: file.name.split('.')[0],
                        poradie: 0,
                    },
                    file
                );

                const record = new ActorPortfolioModel(data);

                this.getActor.addPortfolioItem(record);
                this.$_setState(states.saved);
                this.$refs.uploadBtn.setSuccess('Success', ms);
                this.startPolling();
            } catch (e) {
                this.$refs.uploadBtn.setError('Failed', ms);
                this.$_setState(states.error);
                this.$env.log.error(e);
                this.$bugsnag.notify(e);
            } finally {
                this.$_setState(null, states.idle);
            }
        },

        async submit() {
            if (this.$_stateIs(states.saving)) {
                return;
            }

            this.$_setState(states.saving);

            try {
                await this.getActor.savePortfolio();
                await this.getActor.load('portfolio');
                this.$_setState(states.saved);
            } catch (e) {
                this.$env.log.error(e);
                this.$bugsnag.notify(e);
                this.$_setState(states.error);
            } finally {
                this.$_setState(null, states.idle);
            }
        },

        startPolling() {
            const poll = async () => {
                if (!this.hasUnprocessedAudio) {
                    return;
                }
                await this.getActor.load('portfolio');
                this.poll = setTimeout(poll, 1000);
            };

            if (this.hasUnprocessedAudio) {
                this.poll = setTimeout(poll, 500);
            }
        },

        stopPolling() {
            if (this.poll) {
                clearTimeout(this.poll);
            }
        },
    },

    computed: {
        ...mapGetters([
            'getActor',
            'getActorPortfolio',
            'getSampleMp3Url',
            'getIsLoggedIn',
            'getIsSetActorAccessToken',
            'getActorGallery',
        ]),

        getAudioPortfolio() {
            return this.getActorPortfolio.filter((item: any) => item.file_type == 'audio');
        },

        getTransformedPortfolio() {
            return this.getAudioPortfolio.map((item: ActorPortfolioModel) => ({
                id: item.id,
                file_id: item.file_id,
                file_name: item.file_name,
                nazov: item.nazov,
                url: item.url,
            }));
        },

        hasUnprocessedAudio() {
            return this.getAudioPortfolio.some((i: any) => i.state != 'ready');
        },
    },

    components: {
        VideoGallery,
        PageHeader,
        ScrollTable,
        Mp3Player,
        RatingBanner,
    },
});
